






import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})

export default class LogoCompany extends Vue {
	@Prop() public id!: string;
	@Prop() private name!: string;
	@Prop() public companyLogo!: string;
  uid: number;

  @Watch('id')
  onPropertyChanged(value: number) {
      this.uid = value;
  }

	data() {
		return {
	    uid: this.id,
		}
	}
}
